export default __webpack_public_path__ + "static/media/promo_pt.cf95cdf9.png";